import { useEffect, useMemo, useState } from "react"
import {
	Box, BoxProps,
	Alert, List
} from "@mui/material"

import { ErrorInfo } from "components/controls/errorInfo"
import { Loading } from "components/controls/loading"

import { LvProjectResult, useListLvLog, useListLvProject } from "interface/carenet/lv"
import { SearchDetailResult } from "interface/search"

import { SourceProject } from "../../../types"
import { LvProjectRecord } from "./lvProjectRecord"
import { safeParseDate } from "shared/util"

type LvProjectListProps = {
	search: SearchDetailResult
	searchWord: string
	exclusiveList: SourceProject[]
	onAddProject: (project: SourceProject) => void
} & BoxProps
export const LvProjectList = ({
	search,
	searchWord,
	exclusiveList,
	onAddProject,
	...others
}: LvProjectListProps) => {
	const [selected, setSelected] = useState<LvProjectResult | null>(null)

	const projectListState = useListLvProject(true, search.searchId)
	const projectList = useMemo(
		() => {
			const projectList = projectListState.data?.list.filter(
				p => {
					if (searchWord !== "") {
						if (
							(!p.projectName || !p.projectName.toLowerCase().includes(searchWord.toLowerCase())) &&
							(!p.productName || !p.productName.toLowerCase().includes(searchWord.toLowerCase()))
						) return false
					}
					return !exclusiveList.some(e => e.projectCode === p.projectCode)
				}
			) ?? []
			return projectList
		},
		[projectListState.data, exclusiveList, searchWord]
	)
	const logListState = useListLvLog(selected?.projectCode)
	useEffect(
		() => {
			if (!selected || !logListState.data) return
			if (logListState.data.list.length > 0) {
				onAddProject({
					source: 'lv',
					projectCode: selected.projectCode,
					projectName: selected.projectName ?? '',
					productName: selected.productName ?? null,
					projectDate: safeParseDate(selected.broadcastStartDate) ?? null,
					logList: logListState.data.list
				})
			}
			setSelected(null)
		},
		[logListState.data, onAddProject, selected, setSelected]
	)
	if (projectListState.loading || logListState.loading) return <Loading/>
	if (projectListState.error) return <ErrorInfo error={projectListState.error}/>
	if (!projectListState.data) return <></>
	return (
		<Box {...others}>
			{logListState.loading && <Loading/>}
			<ErrorInfo error={logListState.error}/>
			{projectList.length === 0 ? (
				<Box padding={1}>
					<Alert severity="info">対象が見つかりません.</Alert>
				</Box>
			) : (
				<List disablePadding>
					{projectList.map(project => (
						<LvProjectRecord
							key={`lv-project-${project.projectCode}`}
							project={project}
							onOpenProject={setSelected}
						/>
					))}
				</List>
			)}
		</Box>
	)
}
